export default function ($app) {
	const self = this;
	const shareContainer = $('#shareContainer');
	const service = {};

	self.service = ko.observableArray();
	self.shareEpisode = ko.observable(true);
	self.showShareEpisode = ko.computed(() => $app.currentEpisode() && !$app.episode() ? $app.currentEpisode().isRecorded() : false);
	self.isShow = ko.observable(false);

	self.shareUrl =  ko.computed(function () {
		const host = location.origin;

		if($app.episode()) {
			return host + '/watch/' + $app.episode().key();
		}

		if (self.shareEpisode() && $app.currentEpisode()){
			return host +'/watch/' + $app.currentEpisode().key();
		}

		return host +'/watch/' + $app.event().eventKey();
	});

	function Service(name, handler) {
		this.name = name;
		this.handler = handler;

		self.service().push(this);
		service[name] = handler;
	}

	this.Share = function(type) {
		if(service.hasOwnProperty(type)) {
			service[type]();
		}
	};

	this.show = function() {
		if ($app.currentEpisode()){
			self.shareEpisode($app.currentEpisode().isRecorded());
		} else {
			self.shareEpisode(false);
		}

		shareContainer.fadeIn();

		setTimeout(function(){self.isShow(true)}, 100);
		//$('.popupContainer').not('#shareContainer').slideUp();
		//if(parseInt($('#shareContainer').css('right'))) {
		//	shareContainer.animate({right: 0});
		//} else {
		//	this.hide();
		//}
	};
	this.hide = function() {
		shareContainer.fadeOut();
		self.isShow(false);
		//shareContainer.animate({right: -100});
		return this;
	};

	new Service('vk', function() {
		window.open(
			'http://vk.com/share.php?url=' + encodeURIComponent(self.shareUrl()),
			'vk',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	// new Service('facebook', function() {
	// 	window.open(
	// 		'https://www.facebook.com/dialog/share?app_id=391795404250339&display=popup&href=' + encodeURIComponent(self.shareUrl()),
	// 		'favebook',
	// 		'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
	// 	);
	// });
	new Service('ok', function() {
		window.open(
			'https://connect.ok.ru/offer?url=' + encodeURIComponent(self.shareUrl()),
			'ok.ru',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	new Service('twitter', function() {
		window.open(
			'https://twitter.com/intent/tweet?&url=' + encodeURIComponent(self.shareUrl()),
			'twitter',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	new Service('mailru', function() {
		window.open(
			'https://connect.mail.ru/share?&url=' + encodeURIComponent(self.shareUrl()),
			'Mail.ru',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	new Service('linkedin', function() {
		window.open(
			'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(self.shareUrl()),
			'LinkedIn',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	new Service('google', function() {
		window.open(
			'https://plus.google.com/share?url='  + encodeURIComponent(self.shareUrl()),
			'google',
			'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no,width=600,height=300'
		);
	});
	shareContainer.children('.close').on('click', self.hide);
	// $(document).click(function(event) {
	// 	if (!$(event.target).is("#shareContainer") && self.isShow()){
	// 		self.hide();
	// 	}
	// });
	// shareContainer.on('mouseleave', function() { self.hide(); });
}
